/* modificar texto */
export var TEXTO_ACTUALIZAR = 'TEXTO_ACTUALIZAR';
export var actualizarTexto = function actualizarTexto(textoId, valores) {
  return {
    type: TEXTO_ACTUALIZAR,
    textoId: textoId,
    valores: valores
  };
};
/* 
    activa/desactiva el modo crear texto
    modo === false => desactivado
    modo === TIPO_TEXTO => activado, modo texto (ver constantes textos-usuario)
    modo === TIPO_NOTA => activado, modo nota (ver constantes textos-usuario)
*/

export var TEXTO_MODO_CREAR = 'TEXTO_MODO_CREAR';
export var modoCrearTexto = function modoCrearTexto(modo) {
  return {
    type: TEXTO_MODO_CREAR,
    modo: modo
  };
};
/* crea un texto nuevo */

export var TEXTO_CREAR = 'TEXTO_CREAR';
export var crearTexto = function crearTexto(texto) {
  return {
    type: TEXTO_CREAR,
    texto: texto
  };
};
/* reemplaza los textos actuales por los especificados en textos */

export var TEXTOS_CARGAR = 'TEXTOS_CARGAR';
export var cargarTextos = function cargarTextos(textos) {
  return {
    type: TEXTOS_CARGAR,
    textos: textos
  };
};
/* elimina todos los textos de una pagina */

export var TEXTOS_ELIMINAR = 'TEXTOS_ELIMINAR';
export var eliminarTextos = function eliminarTextos(libroId, numPagina) {
  var numZona = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return {
    type: TEXTOS_ELIMINAR,
    libroId: libroId,
    numPagina: numPagina,
    numZona: numZona
  };
};
/* textos usuario visibles  */

export var MOSTRAR_TEXTOS_USUARIO = 'MOSTRAR_TEXTOS_USUARIO';
export var mostrarTextosUsuario = function mostrarTextosUsuario() {
  return {
    type: MOSTRAR_TEXTOS_USUARIO
  };
};
/* textos usuario ocultos  */

export var OCULTAR_TEXTOS_USUARIO = 'OCULTAR_TEXTOS_USUARIO';
export var ocultarTextosUsuario = function ocultarTextosUsuario() {
  return {
    type: OCULTAR_TEXTOS_USUARIO
  };
};